var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPego(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F2981A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2803 8.2829V16.1298C22.8559 14.7419 19.4864 13.3813 16.1032 12.0208C13.6827 12.9966 11.2622 13.9723 8.81416 14.9755V23.0423C8.71789 22.9873 8.66288 22.9873 8.63537 22.9461C7.02629 20.9809 5.80228 18.8921 5.8848 16.2123C5.95356 13.7799 5.89855 11.3475 5.89855 8.92879C5.89855 8.7364 5.89855 8.544 5.89855 8.29664C9.29551 6.92239 12.6925 5.54815 16.1032 4.16016C19.4864 5.5344 22.8696 6.89491 26.2803 8.2829ZM16.1032 8.87382C18.5237 9.84954 20.9167 10.8115 23.351 11.801V10.2343C20.9167 9.24487 18.4962 8.26915 16.1032 7.30718C13.6414 8.29664 11.2347 9.27235 8.86917 10.2343V11.801C11.3172 10.8115 13.6964 9.84954 16.1032 8.87382Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2637 24.7228V15.935C12.19 15.1572 14.1026 14.393 16.0564 13.6016C19.4138 14.9525 22.7849 16.3034 26.2798 17.7089C25.9633 18.6232 25.6468 19.4965 25.3304 20.4381C22.1657 19.169 19.1111 17.9409 16.0564 16.7264C15.0933 17.1085 14.1439 17.4906 13.1807 17.8863V23.5084C14.0888 24.2316 15.052 25.0094 16.0702 25.8418C17.2673 24.8456 18.4231 23.8904 19.6752 22.8534C18.9047 22.5395 18.2717 22.2802 17.5562 22.0073C17.5287 22.2802 17.5149 22.5122 17.4874 22.8124C17.0609 23.1672 16.5793 23.5493 16.0564 23.986C15.5611 23.5902 15.0933 23.2081 14.6254 22.8397V18.8688C15.0795 18.6914 15.5473 18.4867 16.0427 18.282C18.8221 19.401 21.6153 20.5199 24.4773 21.6662C22.1794 24.8183 19.2487 27.1654 16.0564 29.2805C13.965 27.9432 12.0387 26.4422 10.2637 24.7228Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPego);
export default __webpack_public_path__ + "static/media/pego.4225a262c70b738026e6e714c3fb44cf.svg";
export { ForwardRef as ReactComponent };